<template>
    <list-view-layout :title="$t('services.title')">
        <DataTable stripedRows :value="emailTemplates" style="margin-left: -12px; margin-right: -12px;">
            <Column :header="$t('reservations.col_booking_calendar')">
                <template #body="slotProps">
                    <span class="custom-avatar">{{ slotProps.data.reservation_form.name[0] }}</span>
                    &nbsp;{{ slotProps.data.reservation_form.name }}
                </template>
            </Column>
            <Column :header="$t('reservations.col_template_type')">
                <template #body="slotProps">
                    <div class="status-col">
                        <Tag severity="blue">
                            <span v-if="slotProps.data.type === 'new_client'">{{ $t('reservations.notify_new_client') }}</span>
                            <span v-else-if="slotProps.data.type === 'confirm_client'">{{ $t('reservations.notify_confirm') }}</span>
                            <span v-else-if="slotProps.data.type === 'change_client'">{{ $t('reservations.notify_change') }}</span>
                            <span v-else-if="slotProps.data.type === 'cancel_client'">{{ $t('reservations.notify_cancel') }}</span>
                            <span v-else-if="slotProps.data.type === 'reminder_client'">{{ $t('reservations.notify_reminder') }}</span>
                            <span v-else-if="slotProps.data.type === 'retargeting_client'">{{ $t('reservations.notify_retargeting') }}</span>
                            <span v-else>{{ $t('reservations.notify_unknown') }}</span>
                        </Tag>
                    </div>
                </template>
            </Column>
            <Column :header="$t('common.language')">
                <template #body="slotProps">
                    <lang-flag :iso="slotProps.data.language" :squared="false" />
                </template>
            </Column>
            <Column :header="$t('reservations.col_email_subject')">
                <template #body="slotProps">
                    {{ slotProps.data.subject }}
                </template>
            </Column>
            <Column :header="$t('common.status')">
                <template #body="slotProps">
                    <div class="status-col">
                        <span :class="slotProps.data.active ? 'online' : ''" class="status-show"></span>
                        <span v-if="slotProps.data.active">{{ $t('common.active') }}</span>
                        <span v-else>{{ $t('common.inactive') }}</span>
                    </div>
                </template>
            </Column>
            <Column :header="$t('common.last_change')">
                <template #body="slotProps">
                    {{ moment(slotProps.data.last_update).lang("cs").fromNow() }}
                </template>
            </Column>
            <Column :header="$t('common.created')">
                <template #body="slotProps">
                    {{ moment(slotProps.data.created).lang("cs").fromNow() }}
                </template>
            </Column>
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" severity="secondary" text
                        @click="$router.push({ path: '/app/mail-templates/edit', params: { formId: slotProps.data.id } })" />
                    <Button icon="pi pi-trash" severity="danger" text @click="confirmDeleteProduct(slotProps.data)" />
                </template>
            </Column>
        </DataTable>
    </list-view-layout>
</template>
<script setup>
import ListViewLayout from '../../components/view-components/ListViewLayout.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import moment from 'moment';
import Button from 'primevue/button';
import LangFlag from 'vue-lang-code-flags';
/**
new_client
confirm_client
change_client
cancel_client
reminder_client
retargeting_client
 */
const emailTemplates = [
    {
        id: 1,
        type: 'new_client',
        language: 'cs',
        subject: 'Nová rezervace',
        active: true,
        last_update: new Date(),
        created: new Date('2024-01-05'),
        reservation_form: {
            id: 2,
            name: 'Objednávky na kineziologii',
            provider: 'google',
            status: 'online',
            language: 'cs',
            last_update: new Date(),
            created: new Date('2024-01-05')
        }
    },
    {
        id: 2,
        type: 'confirm_client',
        language: 'en',
        subject: 'Reservation confirming',
        active: false,
        last_update: new Date(),
        created: new Date('2025-01-05'),
        reservation_form: {
            id: 2,
            name: 'Kinesiology One Brain',
            provider: 'google',
            status: 'online',
            language: 'en',
            last_update: new Date(),
            created: new Date('2024-01-05')
        }
    }
];
</script>
<style scoped lang="scss">
.custom-avatar {
    padding: 4px 6px;
    width: 24px;
    height: 24px;
    color: var(--surface-border);
    font-size: .75rem;
    border: 1px solid var(--surface-border);
    border-radius: 6px;
}

.p-datatable {
    font-size: .875rem;
}

.status-col {
    display: flex;
    align-items: center;
    gap: 6px;

    .status-show {
        width: 8px;
        height: 8px;
        border-radius: 99px;
        display: block;
        background: black;

        &.online {
            background: rgb(106, 204, 13);

        }

        &.offline {
            background: rgb(204, 13, 13);

        }
    }
}
</style>
